import { useState } from "react";

import { Plus } from "lucide-react";
import { SupplierEntity } from "../../entitys";
import { SupplierModal } from "../../modals/SupplierModal";
import styles from "../styles.module.scss";
import SuppliersTable from "./SuppliersTable";

export const SuppliersTab: React.FC = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selected, setSelected] = useState<SupplierEntity | null>(null);

  const handleAdd = () => {
    setSelected(null);
    setModalOpen(true);
  };

  const handleEdit = (item: SupplierEntity) => {
    setSelected(item);
    setModalOpen(true);
  };

  const handleDelete = (item: SupplierEntity) => {
    // TODO: delete API
    console.log("Delete ", item);
  };

  const handleSubmit = (data: SupplierEntity, mode: "add" | "edit") => {
    if (mode === "add") {
      // TODO: call create-supplier endpoint
    } else {
      // TODO: call update-supplier endpoint
    }
    setModalOpen(false);
  };

  return (
    <div className={styles.shipment}>
      <div className={styles.toolbar}>
        <button className={styles.blueButton} onClick={handleAdd}>
          <Plus width={16} height={16} stroke="#fff" />
          Add Supplier
        </button>
      </div>

      <SuppliersTable onEdit={handleEdit} onDelete={handleDelete} />

      <SupplierModal
        open={modalOpen}
        initial={selected}
        onClose={() => setModalOpen(false)}
        onSubmit={handleSubmit}
      />
    </div>
  );
};
